module.exports = __webpack_public_path__ + "img/icon_app_name.80bab5f6.png";